import React from 'react';
import { withAuthorization } from '../Session';
import { Container, Row, Col, Button, View ,Form} from 'react-bootstrap';
import './style.css';

import * as ROUTES from '../../constants/routes';
import { NavLink } from 'react-router-dom';

class WebsiteCookiePolicy extends React.Component {
    _isMounted = false;
    state = {
        
    };

    componentWillUnmount() {
        this._isMounted = false;
    }

    async componentDidMount() {
        this._isMounted = true;
     }
    
    
    render() {
        
        return (
            <Container className="page_content">
                <Row>
                <h1>WEBSITE COOKIE POLICY</h1>
<p>This Cookie Notice explains how Shopero uses cookies and similar technologies to recognise you when you visit our websites, such as "www.indiabuys.store & app.indiabuys.co".  It explains what these technologies are and why we use them.
</p>
<h3>What are cookies?</h3>
<p>Cookies are small data files containing small amounts of information that are placed on your computer or mobile device when you visit a website.  Cookies are widely used by website owners in order to make their websites work, or to work more efficiently, as well as to provide reporting information. Cookies help us to remember things about your visit to our Website, such as number of times you visit our website & your preferred time of the visit and other choices/settings and generally make the site easier for you to use.  They may also be used to deliver advertisements that are relevant to you. This isnt always a bad thing. For example, many online retailers use cookies to keep track of the items in a user's shopping cart as they explore the site. Without cookies, your shopping cart would reset to zero every time you clicked a new link on the site. That would make it difficult to buy anything online!
</p>
<h3>Why do we use cookies?</h3>
<p>We use first party and third-party cookies for several reasons. Some cookies are required for technical reasons in order for our Websites to operate, and we refer to these as "essential" or "strictly necessary" cookies. We use these essential Cookies to:
</p>
<ul>
<li>log you into our Website</li>
<li>to protect your security</li>
<li>to help us detect and fight spam, abuse and other activities that violate Shopero user agreements and terms; and</li>
<li>to authenticate your access to the Website.</li>
</ul>
<p>Few other possible data the cookies might capture include:</p>
<ul>
<li>web server cookie stored on your hard drive;</li>
<li>an IP address, assigned to the computer which you use;</li>
<li>the domain server through which you access our service;</li>
<li>the type of computer you're using; and</li>
<li>the type of web browser you're using and version, operating system and platform.</li>
</ul>

<p>The specific types of first and third party cookies served through our Websites and the purposes they perform are described in the table below:
</p>

<table>
<thead>
<tr>
<td>Types of Cookies</td><td>Who serves the Cookies</td><td>How to refuse</td>
</tr>
</thead>
<tbody>
<tr>
<td>
Strictly necessary cookies:
These cookies are strictly necessary to provide you with services available through our Websites and to use some of its features, such as access to secure areas.
</td>
<td>Shopero</td>
<td>
Because these cookies are strictly necessary to deliver the Websites to you, you cannot refuse them. You can block or delete them by changing your browser settings however, as described below under the heading "How can I control cookies?".
</td>
</tr>

<tr>
<td>
Functional cookies:
These cookies are used to enhance the performance and functionality of our Websites but are non-essential to their use. However, without these cookies, certain functionality (like videos) may become unavailable.

</td>
<td></td>
<td>
To refuse these cookies on Shopero Websites only, please follow the instructions below under the heading "How can I control cookies?"
Alternatively, some third parties allow you to refuse their cookies universally by using the relevant opt-out link below:

</td>
</tr>

<tr>
<td>
Performance cookies:
These cookies collect information that is used either in aggregate form to help us understand how our Websites are being used or how effective are marketing campaigns are, or to help us customise our Websites for you.

</td>
<td>Google Analytics</td>
<td>To refuse these cookies on Shopero Websites only, please follow the instructions below under the heading "How can I control cookies?"
Alternatively, some third parties allow you to refuse their cookies universally by using the relevant opt-out link below:
Google Analytics: <a target="_blank" href="https://tools.google.com/dlpage/gaoptout">https://tools.google.com/dlpage/gaoptout</a></td>
</tr>

<tr>
<td>
Targeting cookies:
These cookies are used to make advertising messages more relevant to you. They perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed for advertisers, and in some cases selecting advertisements that are based on your interests.

</td>
<td>Clever Tap</td>
<td>
To refuse these cookies on Shopero Websites only, please follow the instructions below under the heading "How can I control cookies?"
Alternatively, some third parties allow you to refuse their cookies universally by using the relevant opt-out link below:
Clever Tap: <a  target="_blank" href="https://clevertap.com/privacy-policy/">https://clevertap.com/privacy-policy/</a>

</td>
</tr>

</tbody>
</table>

<h3>How can I control cookies?</h3>
<p>You have the right to decide whether to retain cookies and preferences around them.  You can exercise your cookie preferences through the browser cookie settings. You can set or amend your web browser controls to accept or refuse cookies. If you choose to reject cookies, you may still use our website though your access to some functionality and areas of our website may be restricted.   As the means by which you can refuse cookies through your web browser controls vary from browser-to-browser, you should visit your browser's help menu for more information.</p>
<p>You can exercise your preferences with some third-party cookies by clicking on the appropriate opt-out links provided in the cookie table above.</p>
<p>In addition, most advertising networks offer you a way to opt out of targeted advertising.  If you would like to find out more information, please visit <a  target="_blank" href="http://www.aboutads.info/choices/">http://www.aboutads.info/choices/</a> or <a  target="_blank" href="http://www.youronlinechoices.com">http://www.youronlinechoices.com</a> For further information on cookies, including how to see what cookies have been set on your device and how to manage and delete them, visit www.allaboutcookies.org.</p>
<p>We do not control any of the above opt-out links and are not responsible for any choices you make using these mechanisms or the continued availability or accuracy of these mechanisms.</p>

                </Row>
                        
            </Container>
        );
    }
}

const condition = (authUser) => !!authUser;

export default withAuthorization(condition)(WebsiteCookiePolicy);
